<template>
   <div id="app">
      <div style="display: block; height: 100%">
         <v-particles :id="name" :color="['#a34242', '#2C405A']" :speed="0.4">
            <div slot="header">
               <h3 class="subtitle"> v1.2.9</h3>
            </div>
            <div slot="content" style="padding: 0">
               <el-row type="flex" justify="center">
                  <h1 style="font-size: 62px; font-weight: 600; display: flex" class="title">vParticles</h1>
               </el-row>
               <el-row type="flex" justify="center" style="margin: 0">
                  <h2 style="margin: 0" class="subtitle">Vue.js plugin for particle background</h2>
               </el-row>
               <el-row type="flex" justify="center" style="padding: 16px">
                  <el-button @click.stop="$router.push('/docs')" size="large" style="font-size: 16px" type="primary">Get
                     started
                  </el-button>
               </el-row>
            </div>
         </v-particles>
      </div>
   </div>
</template>

<script>
   export default {
      data() {
         return {
            name: 'home'
         }
      }
   };
</script>
<style scoped>
   .title {
      background-color: #a34242;
      color: white;
      padding-left: 10px;
      padding-right: 10px;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-select: none;
   }

   .subtitle {
      background-color: #2C405A;
      color: white;
      padding-left: 10px;
      padding-right: 10px;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-select: none;
   }

   html, body, h1, h2, h3, h4, h5, h6, p, button, input, label {
      font-family: 'Titillium Web', sans-serif;
   }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue